export default "__VITE_ASSET__f0958aed__"